export const calcComis = (sum, comission, comissiontp) => {
  let commission = calculateCommission(sum, comission, comissiontp);
  console.log("Комиссия:", commission);
  return commission;
}

function calculateCommission(receivedAmount, percentage1, percentage2) {
  let paymentAmount = Math.ceil(receivedAmount / (1 - (percentage1 + percentage2) / 100) * 100) / 100;
  let commission1 = Math.ceil(paymentAmount * (percentage1 / 100) * 100) / 100;
  let commission2 = Math.ceil(paymentAmount * (percentage2 / 100) * 100) / 100;
  let totalCommission = commission1 + commission2;
  return totalCommission;
}
